import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { SegmentListItem, SegmentListRequestParams } from '@/models/dictionary/segment-list.model';

export default class GetSegmentListRequest extends ApiResourceMethod<SegmentListItem[]> {
  public perform(filterList: SegmentListRequestParams): Promise<SegmentListItem[]> {
    return this.performer.requestWithMapper(
      { params: filterList },
      ({ data }: BaseResponse<SegmentListItem[]>): SegmentListItem[] => data,
    );
  }
}
